/* eslint-disable */
import * as Types from '../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type OrganisationSettingsOfferedServicesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type OrganisationSettingsOfferedServicesQuery = { viewer?: { __typename: 'Viewer', id: string, organisation: { __typename: 'ViewerOrganisation', id: string, organisationType: Types.OrganisationType, categories: Array<string>, offeredServices: Array<{ __typename: 'OrganisationOfferedService', categoryId: string, projectType: Types.OfferedProjectType }>, categoryProjectTypeMappingOverrides: Array<{ __typename: 'OrganisationCategoryProjectTypeMappingOverride', organisationId: string, categoryId: string, projectType: Types.OfferedProjectType, defaultTemplateId?: string | null, defaultSmartProcess?: string | null }> } } | null };

export type OrganisationCategoryProjectTypeMappingOverrideFieldsFragment = { __typename: 'OrganisationCategoryProjectTypeMappingOverride', organisationId: string, categoryId: string, projectType: Types.OfferedProjectType, defaultTemplateId?: string | null, defaultSmartProcess?: string | null };

export type AddOrganisationOfferedServiceMutationVariables = Types.Exact<{
  input: Types.AddOrganisationOfferedServiceInput;
}>;


export type AddOrganisationOfferedServiceMutation = { addOrganisationOfferedService: { __typename: 'OrganisationOfferedServiceMutationResult', organisation: { __typename: 'ViewerOrganisation', id: string, categories: Array<string>, offeredServices: Array<{ __typename: 'OrganisationOfferedService', categoryId: string, projectType: Types.OfferedProjectType }> } } };

export type RemoveOrganisationOfferedServiceMutationVariables = Types.Exact<{
  input: Types.RemoveOrganisationOfferedServiceInput;
}>;


export type RemoveOrganisationOfferedServiceMutation = { removeOrganisationOfferedService: { __typename: 'OrganisationOfferedServiceMutationResult', organisation: { __typename: 'ViewerOrganisation', id: string, categories: Array<string>, offeredServices: Array<{ __typename: 'OrganisationOfferedService', categoryId: string, projectType: Types.OfferedProjectType }> } } };

export type AddOrganisationCategoryMutationVariables = Types.Exact<{
  input: Types.AddOrganisationCategoryInput;
}>;


export type AddOrganisationCategoryMutation = { addOrganisationCategory: { __typename: 'OrganisationOfferedServiceMutationResult', organisation: { __typename: 'ViewerOrganisation', id: string, categories: Array<string>, offeredServices: Array<{ __typename: 'OrganisationOfferedService', categoryId: string, projectType: Types.OfferedProjectType }> } } };

export type RemoveOrganisationCategoryMutationVariables = Types.Exact<{
  input: Types.RemoveOrganisationCategoryInput;
}>;


export type RemoveOrganisationCategoryMutation = { removeOrganisationCategory: { __typename: 'OrganisationOfferedServiceMutationResult', organisation: { __typename: 'ViewerOrganisation', id: string, categories: Array<string>, offeredServices: Array<{ __typename: 'OrganisationOfferedService', categoryId: string, projectType: Types.OfferedProjectType }> } } };

export type SetOrganisationOfferedServicesMutationVariables = Types.Exact<{
  input: Types.SetOrganisationOfferedServicesInput;
}>;


export type SetOrganisationOfferedServicesMutation = { setOrganisationOfferedServices: { __typename: 'OrganisationOfferedServiceMutationResult', organisation: { __typename: 'ViewerOrganisation', id: string, categories: Array<string>, offeredServices: Array<{ __typename: 'OrganisationOfferedService', categoryId: string, projectType: Types.OfferedProjectType }> } } };

export type ReplaceOrganisationCategoryProjectTypeMappingOverridesMutationVariables = Types.Exact<{
  input: Types.ReplaceOrganisationCategoryProjectTypeMappingOverridesInput;
}>;


export type ReplaceOrganisationCategoryProjectTypeMappingOverridesMutation = { replaceOrganisationCategoryProjectTypeMappingOverrides: Array<{ __typename: 'OrganisationCategoryProjectTypeMappingOverride', organisationId: string, categoryId: string, projectType: Types.OfferedProjectType, defaultTemplateId?: string | null, defaultSmartProcess?: string | null }> };

export const OrganisationCategoryProjectTypeMappingOverrideFieldsFragmentDoc = gql`
    fragment OrganisationCategoryProjectTypeMappingOverrideFields on OrganisationCategoryProjectTypeMappingOverride {
  organisationId
  categoryId
  projectType
  defaultTemplateId
  defaultSmartProcess
}
    `;
export const OrganisationSettingsOfferedServicesDocument = gql`
    query OrganisationSettingsOfferedServices {
  viewer {
    id
    organisation {
      id
      organisationType
      categories
      offeredServices {
        categoryId
        projectType
      }
      categoryProjectTypeMappingOverrides {
        ...OrganisationCategoryProjectTypeMappingOverrideFields
      }
    }
  }
}
    ${OrganisationCategoryProjectTypeMappingOverrideFieldsFragmentDoc}`;

/**
 * __useOrganisationSettingsOfferedServicesQuery__
 *
 * To run a query within a React component, call `useOrganisationSettingsOfferedServicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganisationSettingsOfferedServicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganisationSettingsOfferedServicesQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrganisationSettingsOfferedServicesQuery(baseOptions?: Apollo.QueryHookOptions<OrganisationSettingsOfferedServicesQuery, OrganisationSettingsOfferedServicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganisationSettingsOfferedServicesQuery, OrganisationSettingsOfferedServicesQueryVariables>(OrganisationSettingsOfferedServicesDocument, options);
      }
export function useOrganisationSettingsOfferedServicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganisationSettingsOfferedServicesQuery, OrganisationSettingsOfferedServicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganisationSettingsOfferedServicesQuery, OrganisationSettingsOfferedServicesQueryVariables>(OrganisationSettingsOfferedServicesDocument, options);
        }
export function useOrganisationSettingsOfferedServicesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrganisationSettingsOfferedServicesQuery, OrganisationSettingsOfferedServicesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrganisationSettingsOfferedServicesQuery, OrganisationSettingsOfferedServicesQueryVariables>(OrganisationSettingsOfferedServicesDocument, options);
        }
export type OrganisationSettingsOfferedServicesQueryHookResult = ReturnType<typeof useOrganisationSettingsOfferedServicesQuery>;
export type OrganisationSettingsOfferedServicesLazyQueryHookResult = ReturnType<typeof useOrganisationSettingsOfferedServicesLazyQuery>;
export type OrganisationSettingsOfferedServicesSuspenseQueryHookResult = ReturnType<typeof useOrganisationSettingsOfferedServicesSuspenseQuery>;
export type OrganisationSettingsOfferedServicesQueryResult = Apollo.QueryResult<OrganisationSettingsOfferedServicesQuery, OrganisationSettingsOfferedServicesQueryVariables>;
export const AddOrganisationOfferedServiceDocument = gql`
    mutation AddOrganisationOfferedService($input: AddOrganisationOfferedServiceInput!) {
  addOrganisationOfferedService(input: $input) {
    organisation {
      id
      categories
      offeredServices {
        categoryId
        projectType
      }
    }
  }
}
    `;
export type AddOrganisationOfferedServiceMutationFn = Apollo.MutationFunction<AddOrganisationOfferedServiceMutation, AddOrganisationOfferedServiceMutationVariables>;

/**
 * __useAddOrganisationOfferedServiceMutation__
 *
 * To run a mutation, you first call `useAddOrganisationOfferedServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddOrganisationOfferedServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addOrganisationOfferedServiceMutation, { data, loading, error }] = useAddOrganisationOfferedServiceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddOrganisationOfferedServiceMutation(baseOptions?: Apollo.MutationHookOptions<AddOrganisationOfferedServiceMutation, AddOrganisationOfferedServiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddOrganisationOfferedServiceMutation, AddOrganisationOfferedServiceMutationVariables>(AddOrganisationOfferedServiceDocument, options);
      }
export type AddOrganisationOfferedServiceMutationHookResult = ReturnType<typeof useAddOrganisationOfferedServiceMutation>;
export type AddOrganisationOfferedServiceMutationResult = Apollo.MutationResult<AddOrganisationOfferedServiceMutation>;
export type AddOrganisationOfferedServiceMutationOptions = Apollo.BaseMutationOptions<AddOrganisationOfferedServiceMutation, AddOrganisationOfferedServiceMutationVariables>;
export const RemoveOrganisationOfferedServiceDocument = gql`
    mutation RemoveOrganisationOfferedService($input: RemoveOrganisationOfferedServiceInput!) {
  removeOrganisationOfferedService(input: $input) {
    organisation {
      id
      categories
      offeredServices {
        categoryId
        projectType
      }
    }
  }
}
    `;
export type RemoveOrganisationOfferedServiceMutationFn = Apollo.MutationFunction<RemoveOrganisationOfferedServiceMutation, RemoveOrganisationOfferedServiceMutationVariables>;

/**
 * __useRemoveOrganisationOfferedServiceMutation__
 *
 * To run a mutation, you first call `useRemoveOrganisationOfferedServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveOrganisationOfferedServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeOrganisationOfferedServiceMutation, { data, loading, error }] = useRemoveOrganisationOfferedServiceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveOrganisationOfferedServiceMutation(baseOptions?: Apollo.MutationHookOptions<RemoveOrganisationOfferedServiceMutation, RemoveOrganisationOfferedServiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveOrganisationOfferedServiceMutation, RemoveOrganisationOfferedServiceMutationVariables>(RemoveOrganisationOfferedServiceDocument, options);
      }
export type RemoveOrganisationOfferedServiceMutationHookResult = ReturnType<typeof useRemoveOrganisationOfferedServiceMutation>;
export type RemoveOrganisationOfferedServiceMutationResult = Apollo.MutationResult<RemoveOrganisationOfferedServiceMutation>;
export type RemoveOrganisationOfferedServiceMutationOptions = Apollo.BaseMutationOptions<RemoveOrganisationOfferedServiceMutation, RemoveOrganisationOfferedServiceMutationVariables>;
export const AddOrganisationCategoryDocument = gql`
    mutation AddOrganisationCategory($input: AddOrganisationCategoryInput!) {
  addOrganisationCategory(input: $input) {
    organisation {
      id
      categories
      offeredServices {
        categoryId
        projectType
      }
    }
  }
}
    `;
export type AddOrganisationCategoryMutationFn = Apollo.MutationFunction<AddOrganisationCategoryMutation, AddOrganisationCategoryMutationVariables>;

/**
 * __useAddOrganisationCategoryMutation__
 *
 * To run a mutation, you first call `useAddOrganisationCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddOrganisationCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addOrganisationCategoryMutation, { data, loading, error }] = useAddOrganisationCategoryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddOrganisationCategoryMutation(baseOptions?: Apollo.MutationHookOptions<AddOrganisationCategoryMutation, AddOrganisationCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddOrganisationCategoryMutation, AddOrganisationCategoryMutationVariables>(AddOrganisationCategoryDocument, options);
      }
export type AddOrganisationCategoryMutationHookResult = ReturnType<typeof useAddOrganisationCategoryMutation>;
export type AddOrganisationCategoryMutationResult = Apollo.MutationResult<AddOrganisationCategoryMutation>;
export type AddOrganisationCategoryMutationOptions = Apollo.BaseMutationOptions<AddOrganisationCategoryMutation, AddOrganisationCategoryMutationVariables>;
export const RemoveOrganisationCategoryDocument = gql`
    mutation RemoveOrganisationCategory($input: RemoveOrganisationCategoryInput!) {
  removeOrganisationCategory(input: $input) {
    organisation {
      id
      categories
      offeredServices {
        categoryId
        projectType
      }
    }
  }
}
    `;
export type RemoveOrganisationCategoryMutationFn = Apollo.MutationFunction<RemoveOrganisationCategoryMutation, RemoveOrganisationCategoryMutationVariables>;

/**
 * __useRemoveOrganisationCategoryMutation__
 *
 * To run a mutation, you first call `useRemoveOrganisationCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveOrganisationCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeOrganisationCategoryMutation, { data, loading, error }] = useRemoveOrganisationCategoryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveOrganisationCategoryMutation(baseOptions?: Apollo.MutationHookOptions<RemoveOrganisationCategoryMutation, RemoveOrganisationCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveOrganisationCategoryMutation, RemoveOrganisationCategoryMutationVariables>(RemoveOrganisationCategoryDocument, options);
      }
export type RemoveOrganisationCategoryMutationHookResult = ReturnType<typeof useRemoveOrganisationCategoryMutation>;
export type RemoveOrganisationCategoryMutationResult = Apollo.MutationResult<RemoveOrganisationCategoryMutation>;
export type RemoveOrganisationCategoryMutationOptions = Apollo.BaseMutationOptions<RemoveOrganisationCategoryMutation, RemoveOrganisationCategoryMutationVariables>;
export const SetOrganisationOfferedServicesDocument = gql`
    mutation SetOrganisationOfferedServices($input: SetOrganisationOfferedServicesInput!) {
  setOrganisationOfferedServices(input: $input) {
    organisation {
      id
      categories
      offeredServices {
        categoryId
        projectType
      }
    }
  }
}
    `;
export type SetOrganisationOfferedServicesMutationFn = Apollo.MutationFunction<SetOrganisationOfferedServicesMutation, SetOrganisationOfferedServicesMutationVariables>;

/**
 * __useSetOrganisationOfferedServicesMutation__
 *
 * To run a mutation, you first call `useSetOrganisationOfferedServicesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetOrganisationOfferedServicesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setOrganisationOfferedServicesMutation, { data, loading, error }] = useSetOrganisationOfferedServicesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetOrganisationOfferedServicesMutation(baseOptions?: Apollo.MutationHookOptions<SetOrganisationOfferedServicesMutation, SetOrganisationOfferedServicesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetOrganisationOfferedServicesMutation, SetOrganisationOfferedServicesMutationVariables>(SetOrganisationOfferedServicesDocument, options);
      }
export type SetOrganisationOfferedServicesMutationHookResult = ReturnType<typeof useSetOrganisationOfferedServicesMutation>;
export type SetOrganisationOfferedServicesMutationResult = Apollo.MutationResult<SetOrganisationOfferedServicesMutation>;
export type SetOrganisationOfferedServicesMutationOptions = Apollo.BaseMutationOptions<SetOrganisationOfferedServicesMutation, SetOrganisationOfferedServicesMutationVariables>;
export const ReplaceOrganisationCategoryProjectTypeMappingOverridesDocument = gql`
    mutation ReplaceOrganisationCategoryProjectTypeMappingOverrides($input: ReplaceOrganisationCategoryProjectTypeMappingOverridesInput!) {
  replaceOrganisationCategoryProjectTypeMappingOverrides(input: $input) {
    ...OrganisationCategoryProjectTypeMappingOverrideFields
  }
}
    ${OrganisationCategoryProjectTypeMappingOverrideFieldsFragmentDoc}`;
export type ReplaceOrganisationCategoryProjectTypeMappingOverridesMutationFn = Apollo.MutationFunction<ReplaceOrganisationCategoryProjectTypeMappingOverridesMutation, ReplaceOrganisationCategoryProjectTypeMappingOverridesMutationVariables>;

/**
 * __useReplaceOrganisationCategoryProjectTypeMappingOverridesMutation__
 *
 * To run a mutation, you first call `useReplaceOrganisationCategoryProjectTypeMappingOverridesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReplaceOrganisationCategoryProjectTypeMappingOverridesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [replaceOrganisationCategoryProjectTypeMappingOverridesMutation, { data, loading, error }] = useReplaceOrganisationCategoryProjectTypeMappingOverridesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReplaceOrganisationCategoryProjectTypeMappingOverridesMutation(baseOptions?: Apollo.MutationHookOptions<ReplaceOrganisationCategoryProjectTypeMappingOverridesMutation, ReplaceOrganisationCategoryProjectTypeMappingOverridesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReplaceOrganisationCategoryProjectTypeMappingOverridesMutation, ReplaceOrganisationCategoryProjectTypeMappingOverridesMutationVariables>(ReplaceOrganisationCategoryProjectTypeMappingOverridesDocument, options);
      }
export type ReplaceOrganisationCategoryProjectTypeMappingOverridesMutationHookResult = ReturnType<typeof useReplaceOrganisationCategoryProjectTypeMappingOverridesMutation>;
export type ReplaceOrganisationCategoryProjectTypeMappingOverridesMutationResult = Apollo.MutationResult<ReplaceOrganisationCategoryProjectTypeMappingOverridesMutation>;
export type ReplaceOrganisationCategoryProjectTypeMappingOverridesMutationOptions = Apollo.BaseMutationOptions<ReplaceOrganisationCategoryProjectTypeMappingOverridesMutation, ReplaceOrganisationCategoryProjectTypeMappingOverridesMutationVariables>;